<template>
    <div class="multiple_choice">
        <div class="option_title">
            <img v-if="is_required" style="width:18px;height:18px" src="../image/required.png">
            {{title}}(单选)
            <!-- {{index + 1}}. {{title}}(单选) -->
            <van-image
              width="100%"
              height="100%"
              style="margin-top: 10px;"
              v-if="img_url !== ''"
              :src="img_url"
            />
            <div class="desc">
              {{desc}}
            </div>
        </div>
        <van-radio-group v-model="radio" :disabled = is_done >
            <van-cell-group class="box">
                <van-cell
                    v-for="item in options"
                    :key="item.option_id"
                    :title="item.title"
                    clickable @click="setRadioId(item.option_id)"
                    class="option_detail"
                    :class="radio === item.option_id ? 'selectedClass':''"
                >
                    <template #icon>
                        <van-radio checked-color="#fe6900" class="option_icon" :name="item.option_id" />
                    </template>
                </van-cell>
            </van-cell-group>
        </van-radio-group>
    </div>
</template>

<script>
export default {
  data () {
    return {
      radio: '',
      activeIcon: 'https://img01.yzcdn.cn/vant/user-active.png',
      inactiveIcon: 'https://img01.yzcdn.cn/vant/user-inactive.png',
      isWrite: false, // 判断是否填写该问题的参数
      questionData: {
        question_id: this.question_id,
        is_required: this.is_required,
        topic_id: this.topic_id,
        title: this.title,
        img_url: '',
        desc: '',
        options: this.options
      }
    }
  },
  props: {
    title: {
      type: String
    },
    options: {
      type: Array
    },
    index: {
      type: Number
    },
    is_required: {
      type: Boolean
    },
    topic_id: {
      type: Number
    },
    question_id: {
      type: Number
    },
    is_done: {
      type: Boolean
    },
    desc: {
      type: String
    },
    img_url: {
      type: String
    },
    jump_rules: {
      type: Object
    }
  },
  mounted () {
    this.isMakeOut()
    this.isSequired()
  },
  methods: {
    // 判断用户是否填写该问卷，若填写则返回答案
    isMakeOut () {
      if (this.is_done) {
        for (let i = 0; i < this.options.length; i++) {
          const item = this.options[i]
          if (item.answer) {
            this.radio = item.option_id
            break
          }
        }
      } else {
        this.radio = ''
      }
    },
    // 判断该问题是否存在控制显影的问题
    isShowQuestion (questionId, optionId) {
      const OBJ = {} // 用于存放选中后需要显示的问题的ID
      OBJ[questionId] = []
      const jumpRules = { ...this.jump_rules }
      if (JSON.stringify(jumpRules) !== '{}') {
        for (const key in jumpRules) {
          if (+optionId === +key) {
            jumpRules[key].forEach(item => {
              OBJ[questionId].push(item.next_question_id)
            })
          }
        }
        this.$emit('UpskipQuestionId', OBJ)
      }
    },
    // 选中后整理提交数据
    setRadioId (id) {
      if (this.is_done) return
      this.radio = id
      const arr = JSON.parse(JSON.stringify(this.questionData.options)) // 完美
      arr.forEach(item => {
        if (item.option_id === id) {
          item.answer = true
          this.isShowQuestion(this.questionData.question_id, item.option_id)
        } else {
          item.answer = false
        }
      })
      this.questionData.options = arr
    },
    // 判断问卷是否为必填项
    isSequired () {
      if (!this.is_required) {
        this.isWrite = true
      } else {
        this.isWrite = false
      }
    }
  },
  // 监控填写数据
  watch: {
    radio () {
      if (this.radio !== '') {
        this.isWrite = true
      } else {
        this.isSequired()
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.multiple_choice{
    .option_title{
        margin-bottom: 15px;
        .desc{
          font-size: 13px;
          color: dimgray;
        }
    }
    .img-icon{
        height: 20px;
        margin-right: 10px;
    }
    .option_detail{
        border: 1px solid rgb(184, 177, 177);
        // border-collapse: collapse;
    }
    .option_detail:not(:nth-child(1)){
        border-top: none;
    }
    .selectedClass{
        border: 1px solid #ffdbc1;
        background-color: #fff7f2;
    }
    .option_icon{
        margin-right: 10px;
    }
}
</style>
